














import { Component } from 'vue-property-decorator';
import BaseComponent from './Base';

@Component
export default class NavItem extends BaseComponent {
    protected isOpened: boolean = false;
    protected hasDropdown: boolean = false;

    protected onClick(): void {
        if (this.hasDropdown) {
            this.isOpened = !this.isOpened;
        }
    }

    protected checkDropdowns(): boolean {
        return !!this.$slots.default;
    }

    protected mounted(): void {
        this.hasDropdown = this.checkDropdowns();
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavItem.vue